module.exports = __webpack_public_path__ + "img/categorie-nos-engagements-big.0b40da61.jpg";